export const isURLValid = (url) => {
  try {
    return url.match(/^(http(s)?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&]*)/i);
  } catch (_) {
    return false;
  }
};

export const correctURLToHttpsProtocol = (url) => {
  if (isURLValid(url) && !url.match(/^http(s)?:\/\//)) {
    return `https://${url}`;
  }

  return url;
};
